import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { HeaderStyle } from "../Common/styles/header";
import {
  a11yProps,
  CustomTabPanel,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import AppointmentsTab from "./AppointmentsTab";
import RegistryAppointmentsDashboard from "./RegistryAppointmentsDashboard";
import AppointmentActions from "./AppointmentActions";

const RegistryAppointments = () => {
  const [selectedTab, setSelectedTab] = useState(
    sessionStorage.getItem("reg_appt_tab") || "dashboard"
  );

  const [toggleSlots, setToggleSlots] = useState(false);
  const [viewMode, setViewMode] = useState<"slots" | "cancelled">(
    (sessionStorage.getItem("reg_appt_view_mode") as "slots" | "cancelled") ||
      "slots"
  );
  const [showBookModal, setShowBookModal] = useState(false);

  const handleToggleSlots = () => {
    setToggleSlots((prev) => !prev);
  };

  const handleTabsChange = (_: any, newValue: string) => {
    sessionStorage.setItem("reg_appt_tab", newValue);
    setSelectedTab(newValue);
  };

  const handleManualAppointment = () => {
    setShowBookModal(true);
  };

  const handleToggleViewMode = () => {
    const newMode = viewMode === "slots" ? "cancelled" : "slots";
    setViewMode(newMode);
    sessionStorage.setItem("reg_appt_view_mode", newMode);
    handleToggleSlots();
  };

  return (
    <>
      <Box sx={HeaderStyle}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h2" color="text.primary">
            Appointments
          </Typography>
        </Box>
        <Box sx={{ ml: "auto" }}>
          {selectedTab === "calendar" && (
            <AppointmentActions
              viewMode={viewMode}
              onToggleSlots={handleToggleSlots}
              onToggleViewMode={handleToggleViewMode}
              onManualAppointment={handleManualAppointment}
            />
          )}
        </Box>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={selectedTab} onChange={handleTabsChange}>
          <StyledTab label="Dashboard" value="dashboard" {...a11yProps(0)} />
          <StyledTab label="Calendar" value="calendar" {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <Box sx={{ p: 2.5, height: "calc(100% - 122px)", overflow: "auto" }}>
        <CustomTabPanel value={selectedTab} index={"dashboard"}>
          <RegistryAppointmentsDashboard />
        </CustomTabPanel>
        <CustomTabPanel value={selectedTab} index={"calendar"}>
          <AppointmentsTab
            toggle={toggleSlots}
            refresh={handleToggleSlots}
            showManualBooking={showBookModal}
            setShowManualBooking={setShowBookModal}
            viewMode={viewMode}
          />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default RegistryAppointments;
